import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { ROLE_LABELS, formatPrice } from "@/lib/constants";

export default function Team() {
  const { user } = useAuth();
  const [perf, setPerf] = useState([]);

  useEffect(() => {
    api.get("/performance").then(({ data }) => setPerf(data));
  }, []);

  return (
    <div className="space-y-6" data-testid="team-page">
      <div>
        <h1 className="text-3xl font-bold text-slate-900 font-display">Satış Ekibi Performansı</h1>
        <p className="text-slate-500 mt-1">{user?.role === "agent" ? "Kişisel performansınız" : "Ekip dönüşümleri ve cirolar"}</p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4" data-testid="performance-grid">
        {perf.map((p) => (
          <div key={p.user_id} className="bg-white border border-slate-200 rounded-xl p-5" data-testid={`perf-${p.user_id}`}>
            <div className="flex items-center justify-between mb-3">
              <div>
                <div className="text-lg font-semibold text-slate-900">{p.name}</div>
                <div className="text-xs text-slate-500">{ROLE_LABELS[p.role] || p.role}</div>
              </div>
              <div className="text-right">
                <div className="text-xs uppercase tracking-wider text-slate-500">Dönüşüm</div>
                <div className="text-xl font-bold text-amber-600">%{p.conversion_rate}</div>
              </div>
            </div>
            <div className="grid grid-cols-3 gap-2 text-xs">
              <Mini l="Atanan" v={p.assigned_customers} />
              <Mini l="Görüşülen" v={p.contacted_customers} />
              <Mini l="İlgi" v={p.interest_units} />
              <Mini l="Rezerve" v={p.reservations} />
              <Mini l="Kapora" v={p.deposits} />
              <Mini l="Satış" v={p.sales} />
            </div>
            {user?.role === "admin" && (
              <div className="mt-3 pt-3 border-t border-slate-100">
                <div className="text-xs text-slate-500">Toplam Satış</div>
                <div className="text-lg font-bold text-slate-900">{formatPrice(p.total_sales_try, "TRY")}</div>
                {Object.keys(p.payment_split || {}).length > 0 && (
                  <div className="mt-1 text-xs text-slate-500">
                    Ödeme: {Object.entries(p.payment_split).map(([k, v]) => `${k} (${v})`).join(", ")}
                  </div>
                )}
              </div>
            )}
          </div>
        ))}
        {perf.length === 0 && <div className="text-slate-500">Veri yok.</div>}
      </div>
    </div>
  );
}

function Mini({ l, v }) {
  return (
    <div className="px-2.5 py-2 rounded-md bg-slate-50">
      <div className="text-[10px] uppercase tracking-wider text-slate-500">{l}</div>
      <div className="mt-0.5 text-sm font-semibold text-slate-900">{v ?? 0}</div>
    </div>
  );
}
